import { gql, useApolloClient } from '@apollo/client';
import { get } from 'lodash';

const testWebsiteUrlQuery = gql`
  query testWebsiteUrlQuery(
    $websiteUrl: String!
    $bridgeToken: String!
  ) {
    testWebsiteUrl(websiteUrl: $websiteUrl, bridgeToken: $bridgeToken)
  }
`;

const apolloClient = useApolloClient();

export const websiteUrlValidator = (schema) =>
  schema.test(
    'validWebsiteUrl',
    'The hub cannot connect to the Sana webshop. Make sure the website url is correct.',
    async function (value, context) {
      const {
        websiteUrl,
        bridgeToken,
      } = context.parent;

      if (!websiteUrl || !bridgeToken) return true;

      return apolloClient
        .query({
          query: testWebsiteUrlQuery,
          variables: {
            websiteUrl,
            bridgeToken
          },
        })
        .then((result) => get(result, 'data.testWebsiteUrl'))
        .catch(() => true);
    }
  );
